import React from 'react';

import { KnowledgebaseIcon } from './KnowledgebaseIcon';
import { DocumentationIcon } from './DocumentationIcon';
import { TemplatesIcon } from './TemplatesIcon';

export const TYPE_ICONS: Record<string, React.FC<{ size?: number }>> = {
  knowledgebase: KnowledgebaseIcon,
  documentation: DocumentationIcon,
  templates: TemplatesIcon,
};
